import { render, staticRenderFns } from "./AdminPromotionsView.vue?vue&type=template&id=046166ef&"
import script from "./AdminPromotionsView.vue?vue&type=script&lang=js&"
export * from "./AdminPromotionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports